import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { Typography } from 'seagull';
import { ExclamationLine24 } from 'seagull/icons';
import styles from './FooterErrorMessage.module.scss';
export function FooterErrorMessage(param) {
    let { children, showError, errorMessage, vertical, testId } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: cn(styles.root, {
            [styles.vertical]: vertical
        }),
        "data-testid": testId,
        children: [
            showError && /*#__PURE__*/ _jsxs("div", {
                className: styles.errorMessage,
                children: [
                    /*#__PURE__*/ _jsx(ExclamationLine24, {}),
                    /*#__PURE__*/ _jsx(Typography, {
                        skin: "error",
                        children: errorMessage
                    })
                ]
            }),
            children
        ]
    });
}
